import { FC, memo, useMemo } from 'react';
import { useController } from 'react-hook-form';

import FormControl from '@material-ui/core/FormControl';
import { Skeleton } from '@material-ui/lab';

import { HelperTxt } from '../helperTxt/HelperTxt';
import { NewSelect } from '../newSelect/NewSelect';
import { FormNewSelectProps } from './FormItems.types';

export const FormNewSelect: FC<FormNewSelectProps> = memo(
  ({
    placeholder: _,
    control,
    name,
    variant = 'outlined',
    options,
    required,
    loading = false,
    className,
    ...newSelectProps
  }) => {
    const {
      field,
      fieldState: { error },
    } = useController({
      name,
      control,
      defaultValue: undefined,
    });

    const helperText = useMemo(() => {
      if (error?.message) {
        return error.message;
      }

      if (required) {
        return '*required';
      }

      return '';
    }, [error?.message, required]);

    // Show skeleton when loading
    if (loading) {
      return (
        <FormControl fullWidth className={className}>
          <Skeleton variant="rect" height={56} />
          {required && <Skeleton variant="text" width={80} height={24} style={{ marginTop: 4 }} />}
        </FormControl>
      );
    }

    return (
      <FormControl error={!!error} fullWidth className={className}>
        <NewSelect
          {...field}
          {...newSelectProps}
          // FormNewSelectProps is a Partial of NewSelectProps, but callers always supply options.
          options={options as NonNullable<typeof options>}
          required={required}
          variant={variant}
          error={!!error}
          isValid={!error}
        />

        {helperText && <HelperTxt>{helperText}</HelperTxt>}
      </FormControl>
    );
  },
);
